import { PaymentType } from "@wayke-se/ecom";
const creditAssessmentIsSupported = (options) => {
    const loan = options
        .getPaymentOptions()
        .find((option) => option.type === PaymentType.Loan);
    if (!!loan) {
        return loan.loanDetails.shouldUseCreditScoring();
    }
    return false;
};
const shouldUseCreditAssessment = (data, options) => {
    if (!data.useBankId) {
        return false;
    }
    const paymentIsLoan = !!data.payment && data.payment.paymentType === PaymentType.Loan;
    if (!paymentIsLoan) {
        return false;
    }
    const isSupported = creditAssessmentIsSupported(options);
    if (isSupported) {
        return true;
    }
    return false;
};
export default shouldUseCreditAssessment;
